var map = {
	"./logos/broshura/main-broshura@2x.png": 75791,
	"./logos/folderscheck/main-folderscheck@2x.png": 8967,
	"./logos/handelsangebote/main-handelsangebote@2x.png": 97381,
	"./logos/main-en_AU@2x.png": 50838,
	"./logos/main-en_NZ@2x.png": 14860,
	"./logos/main-en_US@2x.png": 84100,
	"./logos/main-es_ES@2x.png": 6445,
	"./logos/main-es_MX@2x.png": 87184,
	"./logos/main-fr_FR@2x.png": 37509,
	"./logos/main-id_ID@2x.png": 10891,
	"./logos/main-it_IT@2x.png": 16843,
	"./logos/main-pt_BR@2x.png": 5121,
	"./logos/main-pt_PT@2x.png": 58601,
	"./logos/promoqui/main-promoqui@2x.png": 30755,
	"./logos/prospecto/main-prospecto@2x.png": 90127,
	"./logos/tiendeo/main-tiendeo@2x.png": 62589,
	"./logos/volantinofacile/main-volantinofacile@2x.png": 5725,
	"./logos/wogibtswas/main-wogibtswas@2x.png": 76999
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11022;